import { render, staticRenderFns } from "./TradersRequisitesAndDevices.vue?vue&type=template&id=7ed54f85&"
import script from "./TradersRequisitesAndDevices.vue?vue&type=script&lang=js&"
export * from "./TradersRequisitesAndDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports